import { config } from './config';

export async function trackQuestionFeedback(productLink, questionId, feedback, sessionId, customerId, website) {
    const url = `${config.BASE_URL}/track/feedback`;
    const userAgent = navigator.userAgent;
    
    // Convert feedback string to number
    const feedbackValue = feedback === 'up' ? 1 : 0;
    
    const body = {
        q_id: questionId,
        ft: 'question',
        fv: feedbackValue,  // Changed from string to number
        site: website,
        c_id: customerId,
        url: productLink,
        ua: userAgent,
        se_id: sessionId
    }
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
    
    return response;
}